import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes - Data remains fresh for 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes - Cache persists for 30 minutes after inactive
      retry: (failureCount, error) => {
        if (error instanceof Error && error.message.includes('401')) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false, // Prevent unnecessary refetches on window focus
      refetchOnReconnect: true, // Refetch on reconnect to get fresh data
      retryOnMount: false, // Don't retry on mount if data is stale
      networkMode: 'online', // Only fetch when online
      // Performance optimizations
      structuralSharing: true, // Deep compare data to reduce re-renders
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      placeholderData: (previousData: any) => previousData, // Keep previous data as placeholder
    },
    mutations: {
      retry: false,
      networkMode: 'online', // Only mutate when online
    },
  },
});
